var map = {
	"./arrowdown.svg": 726,
	"./arrowup.svg": 565,
	"./check.svg": 625,
	"./checkbox.svg": 964,
	"./clipboardcopy.svg": 508,
	"./confetti.svg": 643,
	"./cross.svg": 453,
	"./dashboard.svg": 629,
	"./link.svg": 783,
	"./magic.svg": 608,
	"./meeting.svg": 58,
	"./sun.svg": 991,
	"./sunset.svg": 393,
	"./target.svg": 892,
	"./timer.svg": 346,
	"./warning.svg": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;